export const isAuthed = (state) => {
  return state.entities.users.isAuthed;
};
